module.exports = __webpack_public_path__ + "static/img/05dac0b9dcdaae48ece1969b8702bfcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro3.png
// module id = WzxS
// module chunks = 1